import { render, staticRenderFns } from "./document.vue?vue&type=template&id=2c8ab919&scoped=true&v-once=true"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ab919",
  null
  
)

export default component.exports